'use strict';

import angular from 'angular';
import grid from 'angular-ui-grid';
import categorySelect from '../../components/form/element/category/select';
import categoryProduct from '../category-product/category-product.component';

export class CategoryComponent {

  closeWindow: Function;

  data;
  category;
  modules;
  module;
  additional;

  /*@ngInject*/
  constructor($scope, Storage, WindowService, $q) {
    this.Storage = Storage;
    this.scope   = $scope;
    this.Promise = $q.defer;

    this.closeWindow = WindowService.delItem;
  }

  $onInit() {
    this.module   = this.data.module;
    this.modules  = this.data.modules;
    this.category = this.data.category || {
      moduleId: this.module._id,
      parentId: this.data.parent ? this.data.parent._id : undefined
    };

    var module = (this.modules || []).filter(module => module._id == this.category.moduleId).shift();
    if(module) {
      this.additional = {
        component: 'category-' + module.resourceName.toLowerCase(),
        category: this.category
      };
    }
  }

  save() {
    return this.Storage.saveCategory(this.category)
      .then(() => this.close())
      .catch(err => console.error(err));
  }

  close() {
    this.closeWindow(this.data.id);
  }
}

export default angular.module('storageApp.category', [
    categorySelect,
    categoryProduct,
  ])
  .component('category', {
    bindings: {data: '='},
    transclude: true,
    template: require('./category.html'),
    controller: CategoryComponent,
    controllerAs: 'categoryCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/category/category.component.js